import { useState } from 'react';

import 'assets/styles/core.css'

import Card from '@material-tailwind/react/Card';
import CardBody from '@material-tailwind/react/CardBody';
import CardFooter from '@material-tailwind/react/CardFooter';

import Input from '@material-tailwind/react/Input';
import Button from '@material-tailwind/react/Button';
import Icon from '@material-tailwind/react/Icon';


export default function ResetPassword() {
    const [success, setSuccess] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    function onButtonClick() {
        setSuccess(true);
    }

    return (
        <div className="bg-image h-screen px-3 md:px-8 flex items-center justify-center flex-col">
            
            <div className="h-2" />
            <Card className="max-w-3xl text-center bg-primary">
            {!success && (
                <>
                    <h3 className="text-white text-4xl">Reset your password?</h3>
                    <div className="h-2" />
                </>
            )}
                <div className="h-2" />
                <CardBody>
                <div className="h-2" />
            {!success && (
                <div className="max-w-3xl text-center w-full">  
                    <div className="h-2" />
                    <div className="mb-4 text-left">
                        <Input
                            outline={false}
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            type="password"
                            color="green"
                            placeholder="New Password"
                            size="regular"
                        />
                    </div>
                    <div className="mb-4 text-left">
                        <Input
                            outline={false}
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                            type="password"
                            color="green"
                            
                            placeholder="Confirm Password"
                            size="regular"
                        />
                    </div>
                    
                </div>
            )}
                </CardBody>
                <CardFooter>
                <Button
                        color="green"
                        className="w-full hover:bg-green hover:text-white hover:shadow-xl hover:pr-2"
                        buttonType="outline"
                        size="lg"
                        ripple="dark"
                        onClick={onButtonClick}
                    >
                        Next
                        <Icon name="arrow_forward" size="sm" />
                    </Button>
                    <div className="h-5" />
                </CardFooter>
            </Card>
        </div>
    );
}
